<template>{{! List renders on the parent goals route. }}</template>
